import api from '@/api/api.js'
import config_api from '@/api/config/_api_config'

export default {
    getListeAccessToPrestation(data) {
        const promise = api().post('/accessibilites/users/type_prestation', data)
        return promise.then((response) => response.data)
    },

    saveConsultationAccessibilite(data) {
        const promise = api().post('/accessibilites/users/access/store', data)
        return promise.then((response) => response.data)
    },

    getAccessCheckerToTypePrestation(data) {
        const promise = api().get('/accessibilites/access/user_id/'+data.auth_id+'/data_type/'+data.data_type)
        return promise.then((response) => response.data)
    },

    getListeRoles() {
        const promise = config_api().get('/roles')
        return promise.then((response) => response.data)
    },

    saveUser(data) {
        const promise = config_api().post('/users/store', data)
        return promise.then((response) => response.data)
    },

    deleteUser(data) {
        const promise = config_api().post('/users/delete', data)
        return promise.then((response) => response.data)
    },

    updateUserProfil(data) {
        const promise = config_api().post('/users/update', data)
        return promise.then((response) => response.data)
    },

    updateUserPassword(data) {
        const promise = config_api().post('/users/update/password', data)
        return promise.then((response) => response.data)
    },

    getRolePersonnels() {
        const promise = config_api().get('/users/minimalist')
        return promise.then((response) => response.data)
    },

    setResetPwdCode(data) {
        const promise = config_api().post('/users/set-reset-password-code', data)
        return promise.then((response) => response.data)
    },

    changePassword(data) {
        const promise = config_api().post('/users/set-new-password', data)
        return promise.then((response) => response.data)
    },
}